import styled, {keyframes} from "styled-components";

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: stretch;
  width: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
    position:relative;
    width: 100%;
    max-width: 716px;
    background-color: var(--panel-body);
    z-index:2;
    padding: 0 1rem;

    box-shadow: rgba(0, 0, 0, 0.5) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;

    img.main-logo{
        display: none;
        image-rendering: -webkit-optimize-contrast;
    }

    img.waves-blue{
        display: none;
    }

    @media(max-width: 1500px){
        max-width: 600px;
    }

    @media(max-width: 1200px){
        max-width: 500px;
    }

    @media(max-width: 1000px){
        max-width: 400px;
    }

    @media(max-width: 816px){
        max-width: 816px;
        img.waves-blue{
            position: absolute;
            display: flex;
            width: 100%;
            bottom: 0;
            z-index: -1;
        }
        
        img.main-logo{
            display: flex;
            width: 100%;
            padding: 0 1rem;
            max-width: 500px;
            margin-top: -100px;
        }
    }
`;

export const Background = styled.div`
  flex: 1; /**Ocupa todo espaco menos 700px */
  background: var(--purple);
  opacity: 1;
  background-size: cover;
  padding: 0 2.5rem 0 4rem;

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  min-width: 420px;

  img.logo{
    max-width: 352px;
    width: 100%;
    image-rendering: -webkit-optimize-contrast;
    @media(max-height: 700px){
        max-width: 320px;
        }
  }

  img.logo-background{
    position: absolute;
    left: 14%;
    top: 0;
    background-size: cover;
    max-height: 100%;
    height: 100%;
  }

  >div{
      font-size: 1.5rem;
      color: var(--orange);
      font-weight: 700;
      width: 100%;
      font-family: 'Montserrat', sans-serif;
      @media(max-width: 1280px){
            font-size: 1.25rem;
        }
        @media(max-height: 700px){
            font-size: 1.25rem;
        }
      p{
        color: #FFF;
      }
      &.big-letters-login{
        font-size: 3rem;
        color: #FFF;
        font-family: 'Open Sans', 'Montserrat', sans-serif;
        p{
            color: var(--orange);
        }
        @media(max-width: 1280px){
            font-size: 2.5rem;
        }
        @media(max-height: 700px){
            font-size: 2rem;
        }
      }
  }

  @media (max-width: 816px){
      &{
          display:none;
      }
  }
`;

const appearFromLeft = keyframes`
    from{
        opacity: 0;
        transform: translateX(-50px);
    }to{
        opacity: 1;
        transform: translateX(0);
    }
`;

export const AnimationContainer = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
    animation: ${appearFromLeft} 1s;
    width: 100%;

    form{
        width: 100%;
        max-width: 500px;
        padding: 0 2rem;
        text-align: center;

        h1{
            display:flex;
            align-items: center; 
            justify-content:center;
            margin-bottom: 48px;
            font-weight: 700;
            font-family: 'Montserrat', sans-serif;
            color: var(--purple-lighter);
            font-size: 2rem;
            img{
                margin: 5px 0 0 10px;
                max-width: 102px;
            }
        }

            >div > a{
                color: var(--input-font-color);
                display: flex;
                align-items: center;
                text-decoration: none;
                transition: 100ms ease;
        
                font-size: 0.9rem;
        
                svg{
                    margin-right: 16px;
                }
        
                &:hover{
                    color: var(--purple);
                    font-weight: bold;
                }
            }

    }


`;

export const Button = styled.button`
   background: var(--main-color);
   color: #fff;
   border-radius: 10px;
   border: 0;
   padding: 0 16px;
   width: 100%;
   height: 56px;
   font-size: 16px;
   margin-top: 8px;
   transition: 280ms ease;    
   &:hover{
       background: var(--purple-darker);
   }        
`;
